// The render pages read app_settings.render_photo_cache_enabled (migration 269)
// and point lib/renderFetch.ts at the worker — or leave it on direct downloads.
import { API_ADDRESSES } from './apiBase';
import { setRenderObjectCache } from './renderFetch';

/** The API base to download through for these settings, or null. Pure. */
export function renderObjectCacheBaseFor(settings: { render_photo_cache_enabled?: boolean } | null | undefined, apiBase: string): string | null {
  return settings?.render_photo_cache_enabled === true ? apiBase : null;
}

export function applyRenderObjectCache(settings: { render_photo_cache_enabled?: boolean } | null | undefined): void {
  setRenderObjectCache(renderObjectCacheBaseFor(settings, API_ADDRESSES.primary));
}
